"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _dom = require("./utils/dom");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

// Expand / Collapse Animation Component
var Expand = /*#__PURE__*/function (_PureComponent) {
  (0, _inheritsLoose2["default"])(Expand, _PureComponent);

  function Expand(props) {
    var _this;

    _this = _PureComponent.call(this, props) || this;
    _this.bindRef = _this.bindRef.bind((0, _assertThisInitialized2["default"])(_this));
    _this.enter = _this.enter.bind((0, _assertThisInitialized2["default"])(_this));
    _this.exit = _this.exit.bind((0, _assertThisInitialized2["default"])(_this));
    _this.instance = null;
    _this.teaserHeight = null;
    _this.animationDuration = 250;
    _this.state = {
      expanded: !!_this.props.showing,
      height: _this.props.showing ? null : 0,
      overflow: _this.props.showing ? null : 'hidden'
    };
    return _this;
  }

  var _proto = Expand.prototype;

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (!this.props.showing && nextProps.showing) {
      this.enter();
    } else if (this.props.showing && !nextProps.showing) {
      this.exit();
    }
  };

  _proto.enter = function enter() {
    var _this2 = this;

    // initial
    this.setState({
      expanded: true,
      height: this.teaserHeight || 0,
      overflow: 'hidden'
    }, function () {
      // animate
      setTimeout(function () {
        return _this2.setState({
          height: (0, _dom.getScrollHeight)(_this2.instance)
        }, function () {
          // clear
          setTimeout(function () {
            return _this2.setState({
              height: null,
              overflow: null
            });
          }, 350);
        });
      }, 0);
    });
  };

  _proto.exit = function exit() {
    var _this3 = this;

    if (!this.instance) {
      return;
    } // initial


    this.setState({
      height: (0, _dom.getScrollHeight)(this.instance),
      overflow: 'hidden'
    }, function () {
      // animate
      setTimeout(function () {
        return _this3.setState({
          height: _this3.teaserHeight || 0
        });
      }, 0); // clear

      setTimeout(function () {
        return _this3.setState({
          expanded: false
        });
      }, 350);
    });
  };

  _proto.bindRef = function bindRef(ref) {
    this.instance = ref;

    if (this.instance && this.props.showTeaser && !this.props.showing) {
      this.teaserHeight = (0, _dom.getOffsetHeight)(this.instance);
      this.setState({
        height: this.teaserHeight
      });
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        showTeaser = _this$props.showTeaser,
        preserve = _this$props.preserve;
    var _this$state = this.state,
        expanded = _this$state.expanded,
        overflow = _this$state.overflow,
        height = _this$state.height;
    return preserve || expanded || showTeaser ? /*#__PURE__*/_react["default"].cloneElement(children, {
      ref: this.bindRef,
      style: {
        overflow: overflow,
        transition: 'height 250ms ease-out',
        height: height
      },
      className: (0, _classnames["default"])(children.props.className, 'expand-content', {
        collapsed: showTeaser && !expanded,
        expanded: showTeaser && expanded,
        'preserve-collapsed': preserve && !expanded
      })
    }) : null;
  };

  return Expand;
}(_react.PureComponent);

exports["default"] = Expand;
Expand.propTypes = {
  showing: _propTypes["default"].bool,
  children: _propTypes["default"].node,

  /** Shows the initial offset height of the child container instead of collapsing it */
  showTeaser: _propTypes["default"].bool,

  /** keeps the expand content on DOM */
  preserve: _propTypes["default"].bool
};
Expand.defaultProps = {
  showTeaser: false
};